import { GridColDef } from "@mui/x-data-grid";
import { Button, Typography } from "@mui/material";
import { InteractionAudit } from "../interfaces/interactionAudit";

const getInteractionAuditColumnDef = (handleAuditClick: (row: InteractionAudit) => void): GridColDef[] => [
    { field: "client_reference_id", headerName: "Client Reference Id", width: 100 },
    { field: "interaction_type", headerName: "Interaction Type", width: 150 },
    { field: "client_name", headerName: "Client Name", width: 150 },
    { field: "agency_name", headerName: "Agency Name", width: 150 },
    { field: "status", headerName: "Status", width: 100 },
    {
        field: "audit",
        headerName: "Audit",
        width: 120,
        renderCell: (params) => (
            <Button sx={{ height: '23px', mt: '-5px' }} variant="contained" color="error" onClick={() => handleAuditClick(params.row)}>
                <Typography sx={{ fontSize: '12px' }}>Audit</Typography>
            </Button>
        ),
    },
    { field: "customer_phone_number", headerName: "Phone Number", width: 100 },
    { field: "dpd_bucket", headerName: "DPD", width: 100 },
    { field: "interaction_mode", headerName: "Mode", width: 100 },
    { field: "l0_audit_by_agency", headerName: "Agency L0", width: 150 },
    { field: "l0_audit_by_client", headerName: "Client L0", width: 150 },
    { field: "interaction_by", headerName: "Interaction By", width: 150 },
    { field: "interaction_date", headerName: "Interaction Date", width: 150 },
    { field: "interaction_audit_id", headerName: "Audit ID", width: 75 },
    { field: "case_id", headerName: "Case ID", width: 75 },
    { field: "interaction_id", headerName: "Interaction History ID", width: 100 },
    { field: "pin_code", headerName: "Pincode", width: 100 },
    { field: "created_by", headerName: "Created By", width: 100 },
    { field: "created_date", headerName: "Created Date", width: 100 },
    { field: "updated_by", headerName: "Updated By", width: 100 },
    { field: "updated_date", headerName: "Updated Date", width: 100 },
];

export default getInteractionAuditColumnDef;
